import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

class SumSex extends Component {
  state = {};
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._onGetData();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _onGetData = async () => {
    const result = await this._onGetDataApi();
    const intReturn = result.data[0].intReturn;
    const sumList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          sumList,
        });
      }
    }
  };
  _onGetDataApi = () => {
    const { apiUrl } = this.props;
    const { contentSerial } = this.props.childProps;

    return axios(apiUrl + "/sexViewSum?contentSerial=" + contentSerial)
      .then((response) => response)
      .catch((error) => {
        //console.log('통계오류')
      });
  };

  render() {
    const { sumList } = this.state;

    return (
      <Fragment>
        {sumList ? (
          <dt>
            <div>
              <span
                style={{
                  height:
                    (sumList[0].man / (sumList[0].man + sumList[0].woman)) *
                      100 +
                    "%",
                }}
              ></span>
              <em>남자</em>
            </div>
            <div>
              <span
                style={{
                  height:
                    (sumList[0].woman / (sumList[0].man + sumList[0].woman)) *
                      100 +
                    "%",
                }}
              ></span>
              <em>여자</em>
            </div>
          </dt>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(SumSex));
